import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useReducer, useRef } from 'react';
import styled from 'styled-components';
import { Box, Button, Container, Heading, Hide, Link, Section, Text, useIntersectionObserver, useWindowSize, Video } from '@miro-site/core';
import { LazyImageAdapter, Headline, Content, ButtonAdapter, LinkAdapter } from '@miro-site/components_utils';
import ProgressBar from './ProgressBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var InfoSliderContainer = styled(Box).attrs({
  $styles: {
    overflow: 'hidden'
  }
}).withConfig({
  displayName: "InfoSlider__InfoSliderContainer",
  componentId: "sc-1cw1lrk-0"
})([""]);
var HeadlineContainer = styled(Box).attrs({
  $styles: {
    maxWidth: [null, 700]
  }
}).withConfig({
  displayName: "InfoSlider__HeadlineContainer",
  componentId: "sc-1cw1lrk-1"
})([""]);
var LinkWrapper = styled(Box).attrs({
  $mt: [16]
}).withConfig({
  displayName: "InfoSlider__LinkWrapper",
  componentId: "sc-1cw1lrk-2"
})(["", "{", "}"], Link, function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    ':focus': _objectSpread({}, theme.focus.outlines.withOffset)
  });
});
var ButtonWrapper = styled(Box).attrs({
  $mt: [24]
}).withConfig({
  displayName: "InfoSlider__ButtonWrapper",
  componentId: "sc-1cw1lrk-3"
})(["", ":{", "}"], Button, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    '&:focus': _objectSpread({}, theme.focus.outlines["default"])
  });
});
var TopContainer = styled(Box).attrs({
  $styles: {
    display: [undefined, 'flex'],
    alignItems: [undefined, 'end'],
    justifyContent: [undefined, 'space-between']
  },
  $mb: [40]
}).withConfig({
  displayName: "InfoSlider__TopContainer",
  componentId: "sc-1cw1lrk-4"
})([""]);
var Tabs = styled(Box).attrs({
  as: 'ul',
  $styles: {
    background: 'primaryIndigo',
    display: 'flex',
    borderRadius: 40
  },
  $p: [5, 8],
  $mt: [40, null]
}).withConfig({
  displayName: "InfoSlider__Tabs",
  componentId: "sc-1cw1lrk-5"
})([""]);
var TabItem = styled(Box).attrs({
  as: 'li',
  $styles: {
    width: ['50%', null],
    marginRight: [15]
  }
}).withConfig({
  displayName: "InfoSlider__TabItem",
  componentId: "sc-1cw1lrk-6"
})(["&:last-child{margin:0;}"]);
var TabButton = styled(Button).attrs(function (_ref3) {
  var $isActive = _ref3.$isActive,
      theme = _ref3.theme;
  return {
    $styles: {
      width: ['100%', null],
      display: ['block', 'inline-block'],
      background: $isActive ? 'primaryWhite' : null,
      fontSize: [14, 18],
      lineHeight: [18, 24],
      color: $isActive ? 'primaryIndigo' : 'primaryWhite',
      borderRadius: 40,
      border: '1px solid transparent',
      transition: 'background 250ms ease, color 250ms ease',
      '.focus-trap': {
        minWidth: [null, 150],
        paddingTop: 11,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 11
      },
      ':hover': {
        background: 'primaryWhite',
        color: 'primaryIndigo'
      },
      ':focus': _objectSpread({}, theme.focus.outlines["default"])
    }
  };
}).withConfig({
  displayName: "InfoSlider__TabButton",
  componentId: "sc-1cw1lrk-7"
})([""]);
var InfoContainer = styled(Box).attrs(function (_ref4) {
  var $isActive = _ref4.$isActive;
  return {
    $styles: {
      display: $isActive ? 'block' : 'none'
    }
  };
}).withConfig({
  displayName: "InfoSlider__InfoContainer",
  componentId: "sc-1cw1lrk-8"
})([""]);
var Row = styled(Box).attrs({
  $styles: {
    display: [undefined, 'flex'],
    flexWrap: [undefined, 'wrap'],
    justifyContent: [undefined, 'space-between']
  },
  $mx: [null, -10]
}).withConfig({
  displayName: "InfoSlider__Row",
  componentId: "sc-1cw1lrk-9"
})([""]);
var Col = styled(Box).attrs(function (_ref5) {
  var $rtl = _ref5.$rtl;
  return {
    $styles: {
      width: [null, '100%'],
      flex: [null, '0 0 100%'],
      ':first-child': {
        width: [null, '41.66%'],
        flex: [null, '0 0 41.66%'],
        order: $rtl ? [null, 2] : [null, 1],
        paddingLeft: $rtl ? [null, 40] : null
      },
      ':last-child': {
        width: [null, '58.33%'],
        flex: [null, '0 0 58.33%'],
        order: $rtl ? [null, 1] : [null, 2]
      }
    },
    $px: [null, 10]
  };
}).withConfig({
  displayName: "InfoSlider__Col",
  componentId: "sc-1cw1lrk-10"
})([""]);
var ItemHeadlineWrapper = styled(Box).attrs({
  $styles: {
    position: 'relative'
  }
}).withConfig({
  displayName: "InfoSlider__ItemHeadlineWrapper",
  componentId: "sc-1cw1lrk-11"
})([""]);
var Title = styled(Text).attrs({
  $styles: {
    cursor: 'pointer',
    opacity: 0.5,
    transition: 'opacity 300ms ease',
    ':hover': {
      opacity: 1
    }
  },
  $pt: 2
}).withConfig({
  displayName: "InfoSlider__Title",
  componentId: "sc-1cw1lrk-12"
})([""]);
var ItemHeadlineBullet = styled(Box).attrs({
  $styles: {
    width: 25,
    height: 25,
    position: 'absolute',
    top: 1,
    left: -43,
    cursor: 'pointer',
    transform: ['scale(0.854)', undefined]
  }
}).withConfig({
  displayName: "InfoSlider__ItemHeadlineBullet",
  componentId: "sc-1cw1lrk-13"
})([""]);
var Items = styled(Box).attrs({
  $styles: {
    width: [null, 400]
  },
  $pt: [null, 40]
}).withConfig({
  displayName: "InfoSlider__Items",
  componentId: "sc-1cw1lrk-14"
})([""]);
var Item = styled(Box).attrs({
  $styles: {
    borderLeft: '1px solid',
    borderColor: 'solutionsGray',
    ':first-child': {
      borderStyle: 'dashed'
    },
    ':last-child': {
      paddingBottom: 0,
      border: 'none'
    }
  },
  $pl: 30,
  $ml: 12,
  $pb: 24
}).withConfig({
  displayName: "InfoSlider__Item",
  componentId: "sc-1cw1lrk-15"
})([""]);
var ItemWrapper = styled(Box).attrs(function (_ref6) {
  var $isActive = _ref6.$isActive;
  return {
    $styles: {
      height: 0,
      opacity: $isActive ? 1 : 0,
      overflow: 'hidden',
      visibility: $isActive ? 'visible' : 'hidden',
      transition: '500ms ease',
      transitionProperty: 'height, padding, opacity, visibility'
    }
  };
}).withConfig({
  displayName: "InfoSlider__ItemWrapper",
  componentId: "sc-1cw1lrk-16"
})([""]);
var ItemInfoWrapper = styled(Box).attrs(function (_ref7) {
  var $isActive = _ref7.$isActive;
  return {
    $pb: $isActive ? 24 : null
  };
}).withConfig({
  displayName: "InfoSlider__ItemInfoWrapper",
  componentId: "sc-1cw1lrk-17"
})([""]);
var Images = styled(Box).attrs(function (_ref8) {
  var $rtl = _ref8.$rtl;
  return {
    $styles: {
      width: [800],
      height: [645],
      position: 'relative',
      "float": $rtl ? 'right' : null
    }
  };
}).withConfig({
  displayName: "InfoSlider__Images",
  componentId: "sc-1cw1lrk-18"
})([""]);
var ShapeContainer = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0
  }
}).withConfig({
  displayName: "InfoSlider__ShapeContainer",
  componentId: "sc-1cw1lrk-19"
})([""]);
var BoardContainer = styled(Box).attrs({
  $styles: {
    width: [null, 860],
    height: [180, 645],
    borderRadius: [8],
    position: ['relative', 'absolute'],
    left: [null, -30],
    top: [null, '50%'],
    transform: [undefined, 'translateY(-50%)'],
    zIndex: 2,
    overflow: 'hidden'
  },
  $mt: [40, null]
}).withConfig({
  displayName: "InfoSlider__BoardContainer",
  componentId: "sc-1cw1lrk-20"
})([""]);
var BoardWrapper = styled(Box).attrs(function (_ref9) {
  var $isActive = _ref9.$isActive,
      $isReversed = _ref9.$isReversed;
  return {
    $styles: {
      height: '100%',
      position: 'absolute',
      top: $isReversed ? '-100%' : '100%',
      left: 0,
      right: 0,
      opacity: $isActive ? 1 : 0,
      transform: $isActive ? "translateY(".concat($isReversed ? '100%' : '-100%', ")") : null,
      visibility: $isActive ? 'visible' : 'hidden',
      transition: '500ms ease',
      transitionProperty: 'transform, opacity'
    }
  };
}).withConfig({
  displayName: "InfoSlider__BoardWrapper",
  componentId: "sc-1cw1lrk-21"
})([""]);
var Image = styled(Box).attrs(function (_ref10) {
  var $isShadow = _ref10.$isShadow;
  return {
    $styles: {
      position: 'absolute',
      left: 30,
      right: 30,
      top: '50%',
      transform: 'translateY(-50%)',
      boxShadow: !$isShadow ? ['0 2px 10px rgba(5, 0, 56, 0.08)', '0 8px 32px rgba(5, 0, 56, 0.08)'] : undefined,
      borderRadius: 8,
      overflow: 'hidden'
    }
  };
}).withConfig({
  displayName: "InfoSlider__Image",
  componentId: "sc-1cw1lrk-22"
})([""]);
var MobileImages = styled(Box).attrs({
  $styles: {
    height: [210, null],
    marginTop: [48, null],
    position: ['relative', undefined]
  }
}).withConfig({
  displayName: "InfoSlider__MobileImages",
  componentId: "sc-1cw1lrk-23"
})([""]);
var MobileShape = styled(Box).attrs({
  $styles: {
    position: ['absolute', undefined],
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}).withConfig({
  displayName: "InfoSlider__MobileShape",
  componentId: "sc-1cw1lrk-24"
})([""]);
var MobileImage = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2
  }
}).withConfig({
  displayName: "InfoSlider__MobileImage",
  componentId: "sc-1cw1lrk-25"
})([""]);
var VideoContainer = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    left: [0, 30],
    right: [0, 30],
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: 2
  }
}).withConfig({
  displayName: "InfoSlider__VideoContainer",
  componentId: "sc-1cw1lrk-26"
})([""]);

var infoSliderReducer = function infoSliderReducer(state, action) {
  var _state$tabs$state$act;

  switch (action.type) {
    case 'setActiveTab':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeTabIndex: action.payload,
        autoPlay: true,
        activeItemIndex: 0
      });

    case 'setActiveItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeItemIndex: action.payload,
        autoPlay: false,
        isReversed: state.activeItemIndex > action.payload
      });

    case 'toggleNextItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeItemIndex: ((_state$tabs$state$act = state.tabs[state.activeTabIndex]) === null || _state$tabs$state$act === void 0 ? void 0 : _state$tabs$state$act.items.length) === state.activeItemIndex + 1 ? 0 : state.activeItemIndex + 1
      });

    case 'togglePause':
      return _objectSpread(_objectSpread({}, state), {}, {
        isPaused: action.payload
      });

    case 'toggleAutoplay':
      return _objectSpread(_objectSpread({}, state), {}, {
        autoPlay: action.payload
      });

    default:
      throw new Error('Unknown action');
  }
};

var InfoSlider = function InfoSlider(props) {
  var _state$tabs$state$act2;

  var id = props.id,
      headline = props.headline,
      tabs = props.tabs,
      shape = props.shape,
      rtl = props.rtl;
  var itemWrapperRefs = useRef([]);
  var containerRef = useRef(null);
  var animationContainer = useIntersectionObserver(containerRef, {
    threshold: 0.5
  });
  var isAnimated = !!(animationContainer !== null && animationContainer !== void 0 && animationContainer.isIntersecting);

  var _useReducer = useReducer(infoSliderReducer, {
    tabs: tabs,
    activeTabIndex: 0,
    activeItemIndex: 0,
    autoPlay: true,
    isPaused: false,
    isReversed: false
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var autoPlayParameters = useRef({
    duration: (_state$tabs$state$act2 = state.tabs[state.activeTabIndex]) === null || _state$tabs$state$act2 === void 0 ? void 0 : _state$tabs$state$act2.items[0].duration
  });

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width,
      height = _useWindowSize.height;

  useEffect(function () {
    dispatch({
      type: 'togglePause',
      payload: !isAnimated
    });
  }, [isAnimated]);
  useEffect(function () {
    itemWrapperRefs.current.forEach(function (itemWrapper, i) {
      var _itemWrapper$firstChi;

      if (!itemWrapper) {
        return;
      }

      itemWrapper.style.height = state.activeItemIndex === i ? "".concat(((_itemWrapper$firstChi = itemWrapper.firstChild) === null || _itemWrapper$firstChi === void 0 ? void 0 : _itemWrapper$firstChi.offsetHeight) || 0, "px") : "0px";
    });
  }, [state.activeItemIndex, state.activeTabIndex, width, height]);
  useEffect(function () {
    if (!state.autoPlay) {
      return;
    }

    if (!state.isPaused) {
      autoPlayParameters.current.startTime = Date.now();
      var timeout = setTimeout(function () {
        var _state$tabs$state$act3, _state$tabs$state$act4, _state$tabs$state$act5;

        dispatch({
          type: 'toggleNextItem'
        });
        autoPlayParameters.current.duration = ((_state$tabs$state$act3 = state.tabs[state.activeTabIndex]) === null || _state$tabs$state$act3 === void 0 ? void 0 : _state$tabs$state$act3.items.length) === state.activeItemIndex + 1 ? (_state$tabs$state$act4 = state.tabs[state.activeTabIndex]) === null || _state$tabs$state$act4 === void 0 ? void 0 : _state$tabs$state$act4.items[0].duration : (_state$tabs$state$act5 = state.tabs[state.activeTabIndex]) === null || _state$tabs$state$act5 === void 0 ? void 0 : _state$tabs$state$act5.items[state.activeItemIndex + 1].duration;
      }, autoPlayParameters.current.duration);
      return function () {
        clearTimeout(timeout);
      };
    }

    if (state.isPaused && autoPlayParameters.current.startTime) {
      autoPlayParameters.current.duration -= Date.now() - autoPlayParameters.current.startTime;
    }
  }, [state, width, height]);
  return /*#__PURE__*/_jsx(Section, {
    "data-place": "Info Slider",
    id: id,
    ref: containerRef,
    children: /*#__PURE__*/_jsx(InfoSliderContainer, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [headline && tabs && /*#__PURE__*/_jsxs(TopContainer, {
          children: [headline.text && /*#__PURE__*/_jsx(HeadlineContainer, {
            children: /*#__PURE__*/_jsx(Headline, _objectSpread({
              tag: "h2",
              size: "mid"
            }, headline))
          }), (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 && /*#__PURE__*/_jsx(Tabs, {
            "data-testid": "tabs-container",
            children: tabs.map(function (tab, index) {
              return /*#__PURE__*/_jsx(TabItem, {
                children: /*#__PURE__*/_jsx(TabButton, {
                  onClick: function onClick() {
                    if (state.activeTabIndex !== index) {
                      dispatch({
                        type: 'setActiveTab',
                        payload: index
                      });
                    }
                  },
                  $isActive: state.activeTabIndex === index,
                  children: tab.title
                })
              }, index);
            })
          })]
        }), tabs.map(function (tab, sectionIndex) {
          var _tab$items, _tab$items2;

          return /*#__PURE__*/_jsx(InfoContainer, {
            $isActive: state.activeTabIndex === sectionIndex,
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                $rtl: rtl,
                children: /*#__PURE__*/_jsx(Items, {
                  children: (_tab$items = tab.items) === null || _tab$items === void 0 ? void 0 : _tab$items.map(function (item, itemIndex) {
                    var _item$headline, _item$headline2;

                    var text = itemIndex > 0 ? itemIndex + '. ' + ((_item$headline = item.headline) === null || _item$headline === void 0 ? void 0 : _item$headline.text) : (_item$headline2 = item.headline) === null || _item$headline2 === void 0 ? void 0 : _item$headline2.text;
                    var title = {
                      headline: {
                        children: text
                      },
                      content: {
                        children: text
                      }
                    };
                    return /*#__PURE__*/_jsxs(Item, {
                      children: [/*#__PURE__*/_jsxs(ItemHeadlineWrapper, {
                        onClick: function onClick() {
                          dispatch({
                            type: 'setActiveItem',
                            payload: itemIndex
                          });
                        },
                        children: [state.activeItemIndex === itemIndex ? /*#__PURE__*/_jsx(Heading, _objectSpread({
                          as: "h3",
                          $variant: "h4"
                        }, title.headline)) : /*#__PURE__*/_jsx(Title, _objectSpread({
                          $variant: "p1"
                        }, title.content)), /*#__PURE__*/_jsx(ItemHeadlineBullet, {
                          children: /*#__PURE__*/_jsx(ProgressBar, {
                            type: itemIndex === 0 ? 'rect' : '',
                            isActive: state.activeItemIndex === itemIndex,
                            isAnimated: state.autoPlay && state.activeItemIndex === itemIndex,
                            isPaused: state.isPaused && state.activeItemIndex === itemIndex,
                            duration: item.duration
                          })
                        })]
                      }), /*#__PURE__*/_jsx(ItemWrapper, {
                        ref: function ref(_ref11) {
                          if (sectionIndex === state.activeTabIndex) {
                            itemWrapperRefs.current[itemIndex] = _ref11;
                          }
                        },
                        $isActive: state.activeItemIndex === itemIndex,
                        children: /*#__PURE__*/_jsxs(ItemInfoWrapper, {
                          $isActive: state.activeItemIndex === itemIndex,
                          children: [/*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, item.description), {}, {
                            textProps: {
                              $styles: {
                                paddingTop: 16
                              },
                              $variant: 'p1',
                              $color: 'greyish'
                            }
                          })), item.link && /*#__PURE__*/_jsx(LinkWrapper, {
                            children: /*#__PURE__*/_jsx(LinkAdapter, _objectSpread({
                              withArrow: true
                            }, item.link))
                          }), item.button && /*#__PURE__*/_jsx(ButtonWrapper, {
                            children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread({
                              arrow: true
                            }, item.button))
                          }), /*#__PURE__*/_jsx(Hide, {
                            $on: ['medium', 'mediumUp', 'mediumDown', 'large'],
                            children: /*#__PURE__*/_jsxs(MobileImages, {
                              children: [shape && (state.activeTabIndex === 1 && state.activeItemIndex === 0 ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(MobileShape, {
                                children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                                  assets: shape,
                                  rootRef: containerRef
                                })
                              })), item.image && /*#__PURE__*/_jsx(MobileImage, {
                                children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                                  assets: item.image,
                                  rootRef: containerRef
                                })
                              }), item.video && /*#__PURE__*/_jsx(VideoContainer, {
                                children: /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, item.video), {}, {
                                  rootRef: containerRef,
                                  togglePlay: state.activeItemIndex === itemIndex,
                                  time: 0,
                                  controls: false,
                                  containerId: "wistia-mobile-".concat(itemIndex, "-").concat(item.video.id)
                                }))
                              })]
                            })
                          })]
                        })
                      })]
                    }, itemIndex);
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                $rtl: rtl,
                children: /*#__PURE__*/_jsx(Hide, {
                  $on: ['small'],
                  children: /*#__PURE__*/_jsxs(Images, {
                    $rtl: rtl,
                    children: [shape && (state.activeTabIndex === 1 && state.activeItemIndex === 0 ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(ShapeContainer, {
                      children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                        assets: shape
                      })
                    })), /*#__PURE__*/_jsx(BoardContainer, {
                      children: (_tab$items2 = tab.items) === null || _tab$items2 === void 0 ? void 0 : _tab$items2.map(function (item, itemIndex) {
                        return /*#__PURE__*/_jsxs(BoardWrapper, {
                          $isActive: state.activeItemIndex === itemIndex,
                          $isReversed: state.isReversed,
                          children: [item.image && /*#__PURE__*/_jsx(Image, {
                            $isShadow: state.activeTabIndex === 1 && state.activeItemIndex === 0,
                            children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                              assets: item.image,
                              rootRef: containerRef
                            })
                          }), item.video && /*#__PURE__*/_jsx(VideoContainer, {
                            children: /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, item.video), {}, {
                              rootRef: containerRef,
                              togglePlay: state.activeItemIndex === itemIndex,
                              time: 0,
                              controls: false,
                              containerId: "wistia-desktop-".concat(itemIndex, "-").concat(item.video.id)
                            }))
                          })]
                        }, itemIndex);
                      })
                    })]
                  })
                })
              })]
            })
          }, sectionIndex);
        })]
      })
    })
  });
};

export default InfoSlider;